import { createContext,useEffect,useReducer } from "react";

export const AthleteAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'ATHLETE_LOGIN':
        return {athlete: action.payload}

        case 'ATHLETE_LOGOUT':
            return {
                athlete:null,
            };
        
        case "UPDATE_ACCOUNT_TYPE":
            return {
                athlete: {
                ...state.athlete,
                account_type: action.payload, // Update account_type
                },
            };
        
         case "UPDATE_ACCOUNT_PHOTO":
                return {
                    athlete: {
                    ...state.athlete,
                    photo: action.payload, // Update photo
                    },
                };

        default:
            return state;    
    }
}

export const AthleteAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        athlete:null
    });

    useEffect(()=>{
        const athelete = JSON.parse(localStorage.getItem('athlete'));
        if(athelete){
            dispatch({type:'ATHLETE_LOGIN', payload:athelete});
        }

    },[]);

    console.log('AthleteAuthContext State ', state);

    return (
        <AthleteAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </AthleteAuthContext.Provider>
    )
}